import React, { useState } from "react";
import { CardActions, IconButton } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import "./template.css";

const Slideshow = ({ image }) => {
  const variants = {
    enter: (direction) => {
      return {
        opacity: 0,
        x: direction > 0 ? 1000 : -1000,
      };
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
    },
    exit: (direction) => {
      return {
        zIndex: 0,
        x: direction < 0 ? 1000 : -1000,
        opacity: 0,
      };
    },
  };
  const [[page, index, direction], setPage] = useState([0, 0, 0]);

  const paginate = (newDirection) => {
    setPage([
      page + newDirection,
      Math.abs((page + newDirection) % image.length),
      newDirection,
    ]);
  };

  return (
    <motion.div className="slideshow">
      <AnimatePresence initial={false} custom={direction}>
        <motion.img
          className="slideshow-images"
          key={page}
          src={image[index]}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { type: "spring", stiffness: 300, damping: 30 },
            opacity: { duration: 0.2 },
          }}
        />
      </AnimatePresence>
      <CardActions>
        <IconButton
          size="small"
          className="prev"
          onClick={() => {
            paginate(-1);
          }}
        >
          <ArrowLeftIcon />
        </IconButton>
        <IconButton
          size="small"
          className="next"
          onClick={() => {
            paginate(1);
          }}
        >
          <ArrowRightIcon />
        </IconButton>
      </CardActions>
    </motion.div>
  );
};

export default Slideshow;
